<template>
  <div>
    <mds-button v-if="!activeStep" variation="flat" @click="onClick()">
      {{ translate('scheduler.modal.cancel.button') }}
    </mds-button>
    <mds-button
      v-else
      icon="angle-left"
      variation="flat"
      @click="$emit('back-step')"
    >
      {{ translate('scheduler.modal.back.button') }}
    </mds-button>
  </div>
</template>

<script>
import { MdsButton } from '@mds/button'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/schedulerModal/config/i18n'
import { CANCEL_MESSAGE } from '@/components/schedulerModal/config/constants'

export default {
  name: 'BackCancelButton',
  components: {
    MdsButton,
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
    }
  },
  props: {
    activeStep: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    onClick() {
      this.$emit('close', false)
      window.chrome?.webview?.postMessage(CANCEL_MESSAGE)
      this.$store.dispatch('getSelectedSchedule', {
        scheduleId: undefined,
        feedId: undefined,
      })
    },
  },
}
</script>
